import { render, staticRenderFns } from "./CollapseMenu.vue?vue&type=template&id=567d3554&scoped=true&"
import script from "./CollapseMenu.vue?vue&type=script&lang=js&"
export * from "./CollapseMenu.vue?vue&type=script&lang=js&"
import style0 from "./CollapseMenu.vue?vue&type=style&index=0&id=567d3554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567d3554",
  null
  
)

export default component.exports